var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "l-popper",
        {
          attrs: {
            trigger: "clickToOpen",
            options: {
              placement: "top-right",
              modifiers: { offset: { offset: "0,10px" } },
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "popper" },
            [
              _vm.isOpenTooltip
                ? _c("SubscriptionTooltip")
                : _c("SaveDesignVault", {
                    attrs: {
                      sku: _vm.sku,
                      designCode: _vm.designCode,
                      designtype: _vm.designtype,
                      designs: _vm.computedDesigns,
                      nameOfDesign: _vm.nameOfDesign,
                      designname: _vm.designname,
                      isPurchased: _vm.isPurchased == true,
                      isFreeForAll: _vm.isFreeForAll == true,
                      priceDisplay: _vm.priceDisplay,
                      allowedCountry: _vm.allowedCountry,
                      iscollection: _vm.iscollection,
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "l-button",
            {
              attrs: { slot: "reference", type: "list-entity-button" },
              nativeOn: {
                click: function ($event) {
                  return _vm.onClick()
                },
              },
              slot: "reference",
            },
            [
              _c("img", {
                attrs: {
                  src: "/static/creativate-icons/vault_24.svg",
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }